module.exports = __webpack_public_path__ + "img/beer_id-31.fea7d493.png";